/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RetrievalMode } from './RetrievalMode';
import {
    RetrievalModeFromJSON,
    RetrievalModeFromJSONTyped,
    RetrievalModeToJSON,
    RetrievalModeToJSONTyped,
} from './RetrievalMode';

/**
 * 
 * @export
 * @interface SearchSettingsOverrides
 */
export interface SearchSettingsOverrides {
    /**
     * 
     * @type {boolean}
     * @memberof SearchSettingsOverrides
     */
    semanticRanker?: boolean | null;
    /**
     * 
     * @type {RetrievalMode}
     * @memberof SearchSettingsOverrides
     */
    retrievalMode?: RetrievalMode | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSettingsOverrides
     */
    semanticCaptions?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SearchSettingsOverrides
     */
    indexFilter?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchSettingsOverrides
     */
    topResults?: number | null;
}



/**
 * Check if a given object implements the SearchSettingsOverrides interface.
 */
export function instanceOfSearchSettingsOverrides(value: object): value is SearchSettingsOverrides {
    return true;
}

export function SearchSettingsOverridesFromJSON(json: any): SearchSettingsOverrides {
    return SearchSettingsOverridesFromJSONTyped(json, false);
}

export function SearchSettingsOverridesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSettingsOverrides {
    if (json == null) {
        return json;
    }
    return {
        
        'semanticRanker': json['semanticRanker'] == null ? undefined : json['semanticRanker'],
        'retrievalMode': json['retrievalMode'] == null ? undefined : RetrievalModeFromJSON(json['retrievalMode']),
        'semanticCaptions': json['semanticCaptions'] == null ? undefined : json['semanticCaptions'],
        'indexFilter': json['indexFilter'] == null ? undefined : json['indexFilter'],
        'topResults': json['topResults'] == null ? undefined : json['topResults'],
    };
}

export function SearchSettingsOverridesToJSON(json: any): SearchSettingsOverrides {
    return SearchSettingsOverridesToJSONTyped(json, false);
}

export function SearchSettingsOverridesToJSONTyped(value?: SearchSettingsOverrides | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'semanticRanker': value['semanticRanker'],
        'retrievalMode': RetrievalModeToJSON(value['retrievalMode']),
        'semanticCaptions': value['semanticCaptions'],
        'indexFilter': value['indexFilter'],
        'topResults': value['topResults'],
    };
}

